  <template >
   <div>
   <div>
     {{this.$session.getAll()}}
      {{ test.token}}
   </div>
   </div>
</template>

<script>
export default {
  computed: {
    test () {
      return this.$store.state.loggedUser[0]
    }
  }
}
</script>
